import myAxios from "../utils/request";
export default {
  addOrder(params) {
    return myAxios.post("/api/orderlink/addorder", params);
  }
};
